import type { IPlaidStore } from "@/common/services/Vendor/Plaid/IPlaidStore";
import { defineStore } from "pinia";

export const PlaidStore = defineStore({
  id: "PlaidStore",
  state: (): IPlaidStore => ({
    plaidLinkToken: "",
    plaidWorkspaceUuid: ""
  })
});